import "./form-tenant.scss";

import { TenantFormSchema } from "@factory/form/form.rule";
import { BUSINESS_TYPE } from "@shared/data/business-type";
import { LabelValue } from "@shared/models/label-value.interface";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputTextareaControl from "@shared/ui/hook-form/input-textarea-control/input-textarea-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = TenantFormSchema;
export function FormTenant() {
  const { control } = useFormContext<TenantFormSchema>();
  const mappedBusinessType = LabelValue.MapArray(
    BUSINESS_TYPE || [],
    (x) => x.name,
    (x) => x.name,
  );

  return (
    <div id="FormTenant" className="tenant flex flex-col md:flex-row gap-4">
      <div className="w-full md:w-1/2">
        <InputControl<InputFormSchema>
          control={control}
          name="owner"
          label="Owner"
          className="w-full"
          containerClassName="pb-2"
          placeholder="Enter owner"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="slug"
          label="Slug"
          className="w-full"
          containerClassName="pb-2"
          placeholder="Enter slug"
          hint="Slugs name must be the same in google bucket"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="businessName"
          label="Business Name"
          className="w-full"
          containerClassName="pb-2"
          placeholder="Enter businessName"
        />
        <DropdownControl<InputFormSchema>
          control={control}
          name="businessType"
          label="Business Type"
          className="w-full"
          containerClassName="pb-2"
          placeholder="Enter businessType"
          options={mappedBusinessType}
        />
        <InputTextareaControl<InputFormSchema>
          control={control}
          name="description"
          label="Description"
          className="w-full"
          containerClassName="pb-2"
          placeholder="Enter description"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="email"
          label="Email"
          className="w-full"
          containerClassName="pb-2"
          placeholder="Enter email"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="mobileNumber"
          label="Mobile Number"
          className="w-full"
          containerClassName="pb-2"
          placeholder="Enter mobileNumber"
        />
      </div>
      <div className="w-full md:w-1/2">
        <InputControl<InputFormSchema>
          control={control}
          name="website"
          label="Website"
          className="w-full"
          containerClassName="pb-2"
          placeholder="Enter website"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="rewardsType"
          label="Rewards Type"
          className="w-full"
          containerClassName="pb-2"
          placeholder="Enter rewardsType"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="postRegistrationLink"
          label="Facebook Link"
          className="w-full"
          containerClassName="pb-2"
          placeholder="Enter facebook link"
        />
        <CheckboxControl<InputFormSchema>
          control={control}
          name="enablePublicBookingTimeSelection"
          label="Disable Public Booking Time Selection"
          containerClassName="pb-2"
        />
        <InputDigitControl<InputFormSchema>
          control={control}
          name="dailyBookingLimit"
          label="Daily Booking Limit"
          className="w-full"
          containerClassName="pb-2"
          placeholder="Enter daily booking limit"
        />
        <InputControl<InputFormSchema>
          control={control}
          name="bookingLimitMessage"
          label="Booking Limit Message"
          className="w-full"
          containerClassName="pb-2"
          placeholder="Enter booking limit message"
        />
        <CheckboxControl<InputFormSchema>
          control={control}
          name="showServicesInPublicBooking"
          label="Show Services in Public Booking"
          containerClassName="pb-2"
        />
        {/* <CheckboxControl<InputFormSchema>
          control={control}
          name="showAppointmentDetails"
          label="Show Appointment Details"
          containerClassName="pb-2"
        /> */}
        <InputDateControl<InputFormSchema>
          control={control}
          name="defaultDate"
          label="Default Date"
          className="w-full"
          containerClassName="pb-2"
          placeholder="Enter default date"
        />
      </div>
    </div>
  );
}

export default FormTenant;
